import React, { Component } from 'react';
import CopyFromPartnerFields from './CopyFromPartnerFields';

class CopyPartnerClearance extends Component {
    state = {
        copyClearances: true,
        copyVisibleCategories: true
    };

    componentDidMount() {
        this.props.onInput(true, 'copyClearances');
        this.props.onInput(true, 'copyVisibleCategories');
    }

    _onCopyClearancesChange = () => {
        const newValue = !this.state.copyClearances;
        this.setState({ copyClearances: newValue });
        this.props.onInput(newValue, 'copyClearances');
    };

    _onCopyVisibleCategorieChange = () => {
        const newValue = !this.state.copyVisibleCategories;
        this.setState({ copyVisibleCategories: newValue });
        this.props.onInput(newValue, 'copyVisibleCategories');
    };

    render() {
        const { staticData, data, onInput, dependencies } = this.props;
        const partnerCopyCount = staticData.for.length;

        return (
            <React.Fragment>
                <p className="u-margin-bottom-2">
                    The clearance settings from the selected partner will be copied to{' '}
                    <span className="u-bold">
                        {partnerCopyCount} {partnerCopyCount === 1 ? 'partner' : 'partners'}
                    </span>{' '}
                    for <span className="u-bold">{staticData.eventName}</span>. If the visible categories do not match,
                    you can choose to copy those settings as well. Carefull you may lose access to categories if they're
                    not visible for the source media partner.
                </p>
                <CopyFromPartnerFields
                    selectLabel="Source Media Partner"
                    selectName="partnerId"
                    selectItems={(dependencies.partners || []).map(x => ({ value: x.id, label: x.name }))}
                    selectValue={data.partnerId}
                    onSelectChange={onInput}
                    copyClearances={this.state.copyClearances}
                    copyVisibleCategories={this.state.copyVisibleCategories}
                    onCopyClearancesChange={this._onCopyClearancesChange}
                    onCopyVisibleCategoriesChange={this._onCopyVisibleCategorieChange}
                    showValidationError={
                        !!data.partnerId && !this.state.copyClearances && !this.state.copyVisibleCategories
                    }
                />
            </React.Fragment>
        );
    }
}

export default CopyPartnerClearance;
